import { BinderItem, BinderActionSet } from "models/BinderItem";

// ホームコレクションのコレクション設定
export const setHomeBinderItems = (binderItems: BinderItem[]) => ({
  type: "binders/list/SET_HOME_BINDER_ITEMS" as const,
  payload: {
    binderItems
  }
});

// マイコレクションのコレクション設定
export const setPersonalBinderItems = (binderItems: BinderItem[]) => ({
  type: "binders/list/SET_PERSONAL_BINDER_ITEMS" as const,
  payload: {
    binderItems
  }
});

// マイコレクションのコレクション追加
export const addPersonalBinderItems = (binderItems: BinderItem[]) => ({
  type: "binders/list/ADD_PERSONAL_BINDER_ITEMS" as const,
  payload: {
    binderItems
  }
});

// 日経コレクションのコレクション追加
export const addNikkeiBinderItems = (binderItems: BinderItem[]) => ({
  type: "binders/list/ADD_NIKKEI_BINDER_ITEMS" as const,
  payload: {
    binderItems
  }
});

export const removePersonalBinderItems = () => ({
  type: "binders/list/REMOVE_PERSONAL_BINDER_ITEMS" as const
});

// 日経コレクションのコレクション設定
export const setNikkeiBinderItems = (binderItems: BinderItem[]) => ({
  type: "binders/list/SET_NIKKEI_BINDER_ITEMS" as const,
  payload: {
    binderItems
  }
});

export const setBinderActionValue = (binderActionValue: BinderActionSet) => ({
  type: "binders/list/SET_BINDER_ACTION_VALUE" as const,
  payload: {
    binderActionValue
  }
});

export const resetBinderActionValue = () => ({
  type: "binders/list/RESET_BINDER_ACTION_VALUE" as const
});

export const setBinderOpenFlgValue = (isBinderOpenFlg: boolean) => ({
  type: "binders/list/SET_BINDER_OPEN_FLG_VALUE" as const,
  payload: {
    isBinderOpenFlg
  }
});

export const changeIsLoading = (isLoadingFlg: boolean) => ({
  type: "binders/list/CHANGE_ISLOADING" as const,
  payload: {
    isLoadingFlg
  }
});

// コレクション追加中フラグ変更
export const changeIsAdding = (isAdding: boolean) => ({
  type: "binders/list/CHANGE_ISADDING" as const,
  payload: {
    isAdding
  }
});

// マイコレクションの総数設定
export const setPersonalTotalCount = (totalCount: number) => ({
  type: "binders/list/SET_PERSONAL_TOTAL_COUNT" as const,
  payload: {
    totalCount
  }
});

// 日経コレクションの総数設定
export const setNikkeiTotalCount = (totalCount: number) => ({
  type: "binders/list/SET_NIKKEI_TOTAL_COUNT" as const,
  payload: {
    totalCount
  }
});

export const setNikkeiOffset = (nikkeiOffset: number) => ({
  type: "binders/list/SET_NIKKEI_OFFSET" as const,
  payload: {
    nikkeiOffset
  }
});

export const setNikkeiLimit = (nikkeiLimit: number) => ({
  type: "binders/list/SET_NIKKEI_LIMIT" as const,
  payload: {
    nikkeiLimit
  }
});

export const setNikkeiListLimit = (nikkeiListLimit: number) => ({
  type: "binders/list/SET_NIKKEI_LIST_LIMIT" as const,
  payload: {
    nikkeiListLimit
  }
});

export const setNikkeiSortValue = (nikkeiSortValue: string) => ({
  type: "binders/list/SET_NIKKEI_SORT_VALUE" as const,
  payload: {
    nikkeiSortValue
  }
});

export const setNikkeiKeyword = (nikkeiKeyword: string) => ({
  type: "binders/list/SET_NIKKEI_KEYWORD" as const,
  payload: {
    nikkeiKeyword
  }
});

// 直前にAPIへリクエストした(確定済みの)日経コレクションの検索キーワード
export const setNikkeiSearchedKeyword = (nikkeiSearchedKeyword: string) => ({
  type: "binders/list/SET_NIKKEI_SEARCHED_KEYWORD" as const,
  payload: {
    nikkeiSearchedKeyword
  }
});

export const setPersonalOffset = (personalOffset: number) => ({
  type: "binders/list/SET_PERSONAL_OFFSET" as const,
  payload: {
    personalOffset
  }
});

export const setPersonalLimit = (personalLimit: number) => ({
  type: "binders/list/SET_PERSONAL_LIMIT" as const,
  payload: {
    personalLimit
  }
});

export const setPersonalListLimit = (personalListLimit: number) => ({
  type: "binders/list/SET_PERSONAL_LIST_LIMIT" as const,
  payload: {
    personalListLimit
  }
});

export const setPersonalSortValue = (personalSortValue: string) => ({
  type: "binders/list/SET_PERSONAL_SORT_VALUE" as const,
  payload: {
    personalSortValue
  }
});

export const setPersonalKeyword = (personalKeyword: string) => ({
  type: "binders/list/SET_PERSONAL_KEYWORD" as const,
  payload: {
    personalKeyword
  }
});

// 直前にAPIへリクエストした（確定済みの）マイコレクションの検索キーワード
export const setPersonalSearchedKeyword = (
  personalSearchedKeyword: string
) => ({
  type: "binders/list/SET_PERSONAL_SEARCHED_KEYWORD" as const,
  payload: {
    personalSearchedKeyword
  }
});

export const setIsSearch = (isSearch: boolean) => ({
  type: "binders/list/SET_IS_SEARCH" as const,
  payload: {
    isSearch
  }
});

export type BindersAction = ReturnType<
  | typeof setHomeBinderItems
  | typeof setPersonalBinderItems
  | typeof setPersonalTotalCount
  | typeof addPersonalBinderItems
  | typeof addNikkeiBinderItems
  | typeof removePersonalBinderItems
  | typeof setNikkeiBinderItems
  | typeof setBinderActionValue
  | typeof resetBinderActionValue
  | typeof setBinderOpenFlgValue
  | typeof changeIsLoading
  | typeof changeIsAdding
  | typeof setNikkeiTotalCount
  | typeof setNikkeiOffset
  | typeof setNikkeiLimit
  | typeof setNikkeiListLimit
  | typeof setNikkeiSortValue
  | typeof setNikkeiKeyword
  | typeof setNikkeiSearchedKeyword
  | typeof setPersonalOffset
  | typeof setPersonalLimit
  | typeof setPersonalListLimit
  | typeof setPersonalSortValue
  | typeof setPersonalKeyword
  | typeof setPersonalSearchedKeyword
  | typeof setIsSearch
>;
